import State from "./state";
import router from '../../router';
import { MenuService } from "src/services";
import { ServiceStorage } from "src/utils/services";
import { Store, ActionTree, ActionContext, createLogger } from "vuex";
import { IUserLoginInfoModel, IMenuModel, IAppModel } from "src/model";
import {generatorDynamicRouter} from "../../router/generator-routers";

/**
 * 修改aTokenToken
 * @param store 
 * @param accessToken 
 */
export function setToken(store: ActionContext<State, any>, token: any): void
{
    store.commit("SET_ACCESS_TOKEN", token.accessToken);
    store.commit("SET_REFRESH_TOKEN", token.refreshToken);
}

/**
 * 修改用户信息
 * @param store 
 * @param accessToken 
 */
export function setUserInfo(store: ActionContext<State, any>, data: any): void
{
    store.commit("SET_USER_INFO", data);
}

/**
 * 切换应用
 * @param apps
 */
export function menuChange(store: ActionContext<State, any>, application: IAppModel): Promise<any>
{
    return new Promise((resolve: any) => {
        ServiceStorage.instance
            .resolve<MenuService>(MenuService)
            .menuChange(application.id)
            .then(({content: res}) => {
                const app = { code: '', name: '', active: true, menu: res.data };
                const newAllAppMenu = [];
                const allAppsMenu = JSON.parse(localStorage.getItem("app_menu") || "[]");
                // 先去除所有默认的，以为此时切换的即将成为前端缓存默认的应用
                allAppsMenu.forEach((item: any) => {
                    if (item.active) {
                        item.active = false;
                    }
                    newAllAppMenu.push(item);
                });
                localStorage.setItem("app_menu", JSON.stringify(allAppsMenu));
                app.name = application.name;
                app.code = application.code;
                const applocationR = [];
                applocationR.push(app);
                localStorage.setItem("app_menu", JSON.stringify(applocationR))
                resolve(res);

                const antDesignmenus = res.data;
                store.dispatch("generateRoutes", antDesignmenus).then(() => {
                   
                    let menuData = store.getters["menuData"];
                    menuData && router.addRoutes(menuData);
                });
            })
            .catch(() => {
                resolve();
            });
    });
}

/**
 * 生成动态路由
 * @param store 
 * @param accessToken 
 */
export function generateRoutes(store: ActionContext<State, any>, data: Array<IMenuModel>): Promise<any>
{
    return new Promise((resolve: any,reject: any) =>
    {
        generatorDynamicRouter(data).then(routers =>
        {
            store.commit('SET_MENU_DATA', routers)
            store.commit('SET_IS_LOGIN', 1)
            resolve()
        }).catch(err =>
        {
            reject(err)
        })
    })
}

export default <ActionTree<State, any>>
{
    menuChange,
    generateRoutes,
    setToken,
    setUserInfo
};
